<template>
  <div class="flex-column">
    <h3 class="card-title mr-2">
      Audit pagina
    </h3>
    <div class="d-flex justify-content-between">
      <div class="disable-ske d-flex">
        <div class="mr-2">
          <TableMainSearchField v-model="search" />
        </div>
        <FormSelect
          v-model="pageName"

          class="form-select"
          min-height="36px"
          id="page-type"
          :white-bg="true"
          :options="pageOptions"
        />
        <FormSelect
          v-model="event"

          class="form-select ml-2"
          id="event-type"
          min-height="36px"
          :white-bg="true"
          :options="eventTypes"
        />
        <FormSelect
          v-model="userUid"

          class="form-select ml-2"
          min-width="200px"
          min-height="36px"
          id="event-type"
          :white-bg="true"
          :options="accountOptions"
        />
      </div>
      <div class="disable-ske d-flex">
        <TableDatePicker
          class="date-picker-shadow"

          :range="true"
          :initial_date.sync="from"
          :final_date.sync="to"
        />
      </div>
    </div>
    <div class="TAILWIND">
      <div class="rounded-sm bg-white border border-gray-200 py-3">
        <div v-if="!loaded">
          <AuditPage v-for="n in 12" :key="n"/>
        </div>
        <div
          v-else
          class="disable-ske"
        >
          <AuditPage
            v-for="event in tableResult"
            :key="event.uid"

            v-bind="event"
            :item="event"
          />
        </div>
      </div>
    </div>

    <div class="PaginationWrapper d-flex justify-content-center pagination-wrapper">
      <Pagination
        :max="max"

        :value="page"
        @input="v => page = v"
      />
    </div>
  </div>
</template>

<script>

import MultipleSelectOptions from '@/layout/Table/MultipleSelectOptions.vue'
import AuditPage from "@/components/AuditPage/AuditPage"
import FormSelect from "@/components/Inputs/FormSelect.vue"
import TableMainSearchField from "@/layout/TableMainSearchField.vue"
import TableDatePicker from '@/components/Inputs/TableDatePickerField.vue'
import Pagination from 'src/layout/Pagination.vue'

import table from "src/mixins/table"
import { translatePageName } from "@/utils/audit-trail"

export default {
  components: {
    Pagination,
    TableDatePicker,
    TableMainSearchField,
    FormSelect,
    MultipleSelectOptions,
    AuditPage
  },
  async created() {
    this.accounts = (await this.axios.get("/api/accounts")).data.results
  },
  mixins: [
    table({
      route: "/api/audit-trail",
      page_size: 100,

      params: {
        search: undefined,
        pageName: undefined,
        event: undefined,
        userUid: undefined,
        from: undefined,
        to: undefined,
      },
      parseParamsBeforeSending: params => {
        const initial = params.from
        const final = params.to

        delete params.from
        delete params.to

        return {
          ...params,
          createdAt: final ? [initial, final] : (initial && [initial]),
        }
      },

      toISOFields: ["from", "to"],
    }),
  ],
  data() {
    return {
      accounts: [],
    }
  },
  computed: {
    pageOptions() {
      const pages = [
        "products",
        "attributes",
        "brands",
        "editor-packages",
        "categories",
        "discounts",
        "websiteProducts",
        "suppliers",
        "synonyms",
        "users",
        "websites",
        "websiteFiles",
        "productFiles",
      ]

      return [
        {
          str: "Alle pagina's",
          value: undefined,
        },
        ...pages.map(page => {
          let str = translatePageName(page)
          str = str[0].toUpperCase() + str.substring(1)

          return { str, value: page }
        }),
      ]
    },
    eventTypes() {
      return [
        {
          str: "Alle evenementen",
          value: undefined,
        },
        {
          str: "Creëer evenement",
          value: 'create',
        },
        {
          str: "Evenement bijwerken",
          value: 'update',
        },
        {
          str: "Gebeurtenis verwijderen",
          value: 'delete',
        },
      ]
    },
    accountOptions() {
      return [
        {
          str: "Alle rekeningen",
          value: undefined,
        },
        ...this.accounts.map(account => ({
          str: account.name,
          value: account.uid,
        }))
      ]
    },
  },
}

</script>

